import React from "react";
import { ReactComponent as Icon } from "../files/left-chevron-icon.svg";
import ISVGIconProps from "../ISVGIconProps";

const LeftChevronIcon = ({
    fill,
    style = {},
    className = "",
}: ISVGIconProps) => {
    return <Icon className={className} fill={fill} style={style} />;
};

export default LeftChevronIcon;
